import React from 'react';
import { Box, Typography } from '@mui/material';

function Page2SubPageC1() {
  return (
    <Box p={4}>
      <Typography variant="h4">Popular</Typography>
    </Box>
  );
}

export default Page2SubPageC1;
